import { DateTime } from 'luxon';

export function getTimestampSummaryValidationStatus(
  globalTimeRange,
  timestampSummary,
) {
  const maxEarliest = DateTime.fromISO(
    timestampSummary?.maxEarliestDataTimestamp || '',
  )
    .startOf('day')
    .plus({ days: 1 });
  const minLatest = DateTime.fromISO(
    timestampSummary?.minLatestDataTimestamp || '',
  )
    .endOf('day')
    .minus({ days: 1 });
  const currentStart = DateTime.fromMillis(globalTimeRange.start);
  const currentEnd = DateTime.fromMillis(globalTimeRange.end);

  const startTooEarly = currentStart < maxEarliest;
  const endTooLate = currentEnd > minLatest;

  const isOutOfBounds = startTooEarly || endTooLate;
  const isCompletelyOutside =
    currentEnd < maxEarliest || currentStart > minLatest;
  const isInverted = maxEarliest > minLatest;
  const isCompletelyInside =
    currentStart >= maxEarliest && currentEnd <= minLatest;

  const adjustedStart = startTooEarly ? maxEarliest : currentStart;
  const adjustedEnd = endTooLate ? minLatest : currentEnd;

  const safeAdjustedRange =
    adjustedStart > adjustedEnd
      ? [maxEarliest, minLatest]
      : [adjustedStart, adjustedEnd];

  return {
    startTooEarly,
    endTooLate,
    isOutOfBounds,
    isCompletelyOutside,
    isCompletelyInside,
    isInverted,
    maxEarliest,
    minLatest,
    adjustedRange: safeAdjustedRange,
  };
}
